import React, { lazy } from 'react';
const LandingPage = lazy(() => import("views/LandingPage/LandingPage"));
const AboutUs = lazy(() => import('views/Sections/SectionAboutUs.tsx'))
const Services = lazy(() => import('views/Sections/SectionServices.tsx'))
const AIInvestments = lazy(() => import('views/Sections/SectionAIInvestments.tsx'))
const PortfolioDetail = lazy(() => import('views/Sections/ModelPortfolios/PortfolioDetail.tsx'))
const AIAnalytics = lazy(() => import('views/Sections/SectionAIAnalytics.tsx'))
const CompanyAnalytics = lazy(() => import('views/Sections/CompanyAnalytics/StandalonePage/CompanyAnalyticsPage'))
const Questionnaire = lazy(() => import('views/Questionnaire/Questionnaire.tsx'))
const ContactUs = lazy(() => import('views/Sections/SectionContactUs.jsx'))
const BusinessContinuity = lazy(() => import('views/BusinessContinuity/BusinessContinuity.jsx'))
const PrivacyPolicy = lazy(() => import('views/PrivacyPolicy/PrivacyPolicy.jsx'))
const CommTransAct = lazy(() => import('views/CommTransAct/CommTransAct.jsx'))
const NotFoundPage = lazy(() => import('views/ErrorPage/NotFound.jsx'))

const publicRoutes = [
  {
    path: '/',
    name: 'Home',
    component: LandingPage
  },
  {
    path: '/about-us',
    name: 'About Us',
    component: AboutUs
  },
  {
    path: '/services',
    name: 'Services',
    component: Services
  },
  {
    path: '/ai-investments',
    name: 'AI Investments',
    component: AIInvestments
  },
  {
    path: '/portfolio/:portfolio_id',
    name: 'Portfolio Details',
    component: PortfolioDetail
  },
  {
    path: '/ai-analytics',
    name: 'AI Analytics',
    component: AIAnalytics
  },
  {
    path: '/company-analytics/:id',
    name: 'Company Analytics',
    component: CompanyAnalytics
  },
  {
    path: '/questionnaire',
    name: 'Questionnaire',
    component: Questionnaire
  },
  {
    path: '/contact',
    name: 'Contact',
    component: ContactUs
  },
  {
    path: '/legal/specified-commercial-transactions-act',
    name: 'Specified Commercial Transactions Act',
    component: CommTransAct
  },
  {
    path: '/legal/privacy-policy',
    name: 'Privacy Policy',
    component: PrivacyPolicy
  },
  {
    path: '/legal/business-continuity',
    name: 'Business Continuity',
    component: BusinessContinuity
  },
  {
    path: '*',
    name: 'Page Not Found',
    component: NotFoundPage
  }
];

const privateRoutes = [

]

export { privateRoutes, publicRoutes };

